import { FileResponse, LogsClient } from "@api/apiClient";
import axios from "@api/axiosInstance";
import { useQuery } from "@tanstack/react-query";

const logsClient = new LogsClient(undefined, axios);

export const useLogFilenames = (options?: any) => {
  return useQuery<string[]>({
    ...options,
    queryKey: ["logFilenames"],
    queryFn: async () => logsClient.getLogFilenames(),
  });
};

export const useLogFileContents = (filename: string, options?: any) => {
  return useQuery<FileResponse>({
    ...options,
    queryKey: ["logfile", filename],
    queryFn: async () => logsClient.getLogFileContents(filename),
  });
};
